<div class="aprova-loading-bar">
  @if (title) {
    <p class="aprova-loading-bar__title">{{ title }}</p>
  }
  <div class="aprova-loading-bar__container">
    <div class="aprova-loading-bar__progress"></div>
  </div>
</div>
